// VehicleCard.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';

const VehicleCard = ({ vehicle }) => {
  return (
    <Card className="h-100">
      <Card.Img 
        variant="top" 
        src={vehicle.image_url} 
        alt={`${vehicle.make} ${vehicle.model}`}
        style={{ height: '200px', objectFit: 'cover' }}
      />
      <Card.Body>
        <Card.Title>{vehicle.make} {vehicle.model} ({vehicle.year})</Card.Title>
        <Card.Text>
          <div>Price: ${vehicle.price.toLocaleString()}</div>
          <div>Mileage: {vehicle.mileage.toLocaleString()} miles</div>
          <div>Condition: {vehicle.vehicle_condition}</div>
        </Card.Text>
        <Button variant="primary" className="w-100">
          View Details
        </Button>
      </Card.Body>
    </Card>
  );
};

export default VehicleCard;